var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPwCFunctIconsCallFillBlackRgb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Call") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88,72.76a5.53,5.53,0,0,0-2.74-4.09L67.45,58.44a5.57,5.57,0,0,0-6.71.89l-3.5,3.5a2.57,2.57,0,0,1-3.43.19,100.9,100.9,0,0,1-8.07-7.26,100.9,100.9,0,0,1-7.26-8.07,2.57,2.57,0,0,1,.19-3.43l3.5-3.5a5.57,5.57,0,0,0,.89-6.71L32.83,16.29a5.57,5.57,0,0,0-8.76-1.16L18.8,20.4c-3.68,3.68-3.74,10.41-.16,19,3.43,8.21,9.84,17.25,18,25.45s17.24,14.62,25.46,18A29.65,29.65,0,0,0,73.29,85.5a10.64,10.64,0,0,0,7.81-2.8l5.27-5.28A5.52,5.52,0,0,0,88,72.76Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwCFunctIconsCallFillBlackRgb);
export default __webpack_public_path__ + "static/media/PwC_Funct_Icons_Call_Fill_Black_RGB.7c94074447952295eeaf15f87ce37cec.svg";
export { ForwardRef as ReactComponent };